import { Alert, Slide, Snackbar, SnackbarCloseReason } from "@mui/material";
import { connect } from "react-redux";
import { bindActionCreators, Dispatch } from "redux";
import { hideNotification } from "../actions";
import { Notification, State } from "../types";
import { SlideProps } from "@mui/material/Slide";
import { FormattedMessage } from "react-intl";

type StateProps = {
    notification: Notification;
};

type DispatchProps = {
    hideNotification: () => void;
};

const mapStateToProps = (store: State) => ({
    notification: store.notification,
});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators({ hideNotification }, dispatch);

type Props = StateProps & DispatchProps;

function SlideTransition(props: SlideProps) {
    return <Slide {...props} direction="down" />;
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)((props: Props) => {
    const { notification } = props;

    const handleClose = (_: any, reason: SnackbarCloseReason) => {
        if (reason === "clickaway") {
            return;
        }
        props.hideNotification();
    };

    return (
        <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "right" }}
            open={notification.show}
            autoHideDuration={5000}
            onClose={handleClose}
            slots={{
                transition: SlideTransition,
            }}
        >
            <Alert
                severity={notification.variant}
                sx={{ width: "100%" }}
                variant="filled"
                onClose={() => props.hideNotification()}
            >
                <FormattedMessage {...notification.message} values={notification.messageVars} />
            </Alert>
        </Snackbar>
    );
});
